import { render, staticRenderFns } from "./HomeAnnouncement.vue?vue&type=template&id=8419e9ca"
import script from "./HomeAnnouncement.vue?vue&type=script&lang=js"
export * from "./HomeAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./HomeAnnouncement.vue?vue&type=style&index=0&id=8419e9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports